import React from 'react';
import useInputValidation, { IInputValitationResponse } from '../../../hooks/input-validation-hook';
import { IValidationGroup } from '../../../hooks/validation-group/validation-group-hook';
import FontBody4 from '../../fonts/font-body4/font-body4';
import './textarea.scss';

export enum TEXTAREA_VARIANTS {
    DEFAULT = 'default',
    FIT_CONTENT = 'fit-content',
}

interface ITextareaProps {
	placeholder?: string,
	value?: string;
	onChange?: (value: any) => void;
	disabled?: boolean;
	required?: boolean;
    maxLength?: number;
    showCharactersCount?: boolean;
	validationGroup?: IValidationGroup;
    validationCallback?: () => IInputValitationResponse,
    variant?: TEXTAREA_VARIANTS,
}

export const Textarea: React.FC<ITextareaProps> = ({ 
	value, placeholder, onChange, disabled, required, maxLength, showCharactersCount, validationGroup, validationCallback, variant = TEXTAREA_VARIANTS.DEFAULT
}) => {
	const isValid = useInputValidation({ value, validationGroup, required, validationCallback });

    const adjustTextareaSize = (e:React.ChangeEvent<HTMLTextAreaElement>) => {
        if (variant === TEXTAREA_VARIANTS.FIT_CONTENT) {
            const target = e.target;
            target.style.height = "17px";
            target.style.height = (target.scrollHeight) + "px";
        }
    }

	const handleOnChange = (e:React.ChangeEvent<HTMLTextAreaElement>) => {
        adjustTextareaSize(e);

		const value = e.target.value;

		onChange && onChange(value);
	}

	return(
		<div className={`textarea ${variant}`}>
			<textarea className={`${ !isValid ? 'invalid' : ''}`}
				disabled={disabled}
				placeholder={placeholder}
				onChange={handleOnChange} 
				value={value ?? ''} 
                maxLength={maxLength}
				/>
            
            {showCharactersCount &&
                <div className="letter-count">
                    <FontBody4>
                        {(value ?? '').length}
                        {!!maxLength &&
                            <> / {maxLength}</>
                        }
                    </FontBody4>
                </div>
            }
		</div>
	)
};